export let getAccount = `query SearchAccount($OperationList: [OperationList]){
    SearchAccount(OperationList:$OperationList){
            ID
            Name
            AccountGUID
            Code
            Description
            ParentId
            LocationGuid
            IsDefault
            State{
                Name
            }
            IsActorSpecific
            IsGroupHeader
            LanguageGuid
            GroupGuid
            Depth
            PathIndex
            AccTypeId
            NumericalHirarchy
            IsActorSpecific
            Type{
                Name
                AccTypeGUID
                Code
                LanguageGuid
                ParentID
                ID
                GroupGuid
              }
        }
    }`;